// routes
global.ROUTE_LOGIN = ''
global.ROUTE_ANY = '/*'
global.ROUTE_HOME = '*'

// general
global.TABLERO_LIST = '/lista-areas'
global.TABLERO_DETAIL = '/detalle-tableros'
global.TABLERO_DETAIL_ALL = '/lista-areas'
global.TABLERO_DETAILBI = '/detalle-tablero-bi'
global.ChatAI = '/chat-AI'

// tableros url
global.TABLERO = '/dashboard'
global.TABLERO_LINK = '/dashboard-link'
global.AREAS = '/Areas'
global.AREAS_CREATE = '/crear-temas'
global.EMPRESAS_CREATE = '/empresas'
global.GRUPOS_CREATE = '/grupos'
global.EMPGROUPCARD_CREATE = '/empresas-grupos'

global.DETAUL_HOME = '/lista-areas'
// Dasboard URL
global.DASHBOARD = '/dashboard'

// Seguridades
global.USUARIOS = '/usuarios'
global.ROLES = '/roles'

// Seguridades BI
global.USUARIOS_CREATE = '/Usuarios-BI'
global.BI_ROLES = '/bi-roles'

// General
global.PERFIL_USER = '/user/perfil'